import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { OtpVerification, resetPassword } from "../../../apis/otpVerify";
import { OtpValues } from "../../../lib/initialvalues/initialvalues";
import { OtpSchema } from "../../../Validations/otpValidations";
import { StorageToken } from "../../../apis/loginApi";
import { useRef } from "react";

const Otp = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  
  const navigate = useNavigate();
  const otpInputs = useRef([]);

  const email = localStorage.getItem("email");
  const ResendOtp = async () => {
    try {
      formik.resetForm();
      setLoading(true);
      setErrorMessage("");
      const res = await resetPassword({ email: email });
      if (res.data.success === true) {
        setLoading(false);
        setSuccessMessage("OTP has sent to your email sucessfully");
      } else if (res.data.success === false) {
        setErrorMessage(res.data.message);
        setLoading(false);
      }
    } catch (err) {
      setErrorMessage("An error occurred while reset.");
    }
  };

  const formik = useFormik({
    initialValues: OtpValues,
    validationSchema: OtpSchema,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        const otp =
          values.otp1 +
          values.otp2 +
          values.otp3 +
          values.otp4 +
          values.otp5 +
          values.otp6;
        const res = await OtpVerification({ email: email, otp: otp });
        if (res.data.success === true) {
          await StorageToken({ otp: res.data.result.otp });
          setLoading(false);
          setSuccessMessage(res.data.result);
          navigate("/change-password");
        } else {
          setErrorMessage(res.data.message);
          setLoading(false);
        }
        formik.resetForm();
      } catch (err) {
        setErrorMessage("Please Enter Valid OTP");
        setLoading(false);
      }
    },
  });

  const handleOtpChange = (index, event) => {
    const input = event.target;
    if (input.value && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    } else if (!input.value && index > 0) {
      otpInputs.current[index - 1].focus();
    }
    formik.handleChange(event);
  };
  const backClick = () => {
    navigate("/");
  };
  return (
    <>
      <div className="account-page o">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              <div className="account-box">
                <div className="account-wrapper">
                  <i
                    className="fa-solid fa-xmark"
                    style={{ fontSize: "20px", marginLeft: "400px" }}
                    onClick={backClick}
                  />
                  <h3 className="account-title">OTP</h3>

                  <p className="account-subtitle">Verification your account</p>

                  {(errorMessage || successMessage) && (
                    <p
                      className={
                        errorMessage !== ""
                          ? "text-danger text-center"
                          : successMessage !== ""
                          ? "text-success text-center"
                          : ""
                      }
                      style={{ fontSize: "16px" }}
                    >
                      {errorMessage || successMessage}
                    </p>
                  )}
                  <form onSubmit={formik.handleSubmit}>
                    <div className="otp-wrap d-flex justify-content-between">
                      {[1, 2, 3, 4, 5, 6].map((index) => (
                        <div key={index} className="otp-input-wrapper">
                          <input
                            ref={(el) => (otpInputs.current[index - 1] = el)}
                            type="text"
                            placeholder=""
                            maxLength={1}
                            className="otp-input"
                            name={`otp${index}`}
                            onBlur={formik.handleBlur}
                            value={formik.values[`otp${index}`]}
                            onChange={(event) =>
                              handleOtpChange(index - 1, event)
                            }
                            readOnly={false}
                          />
                        </div>
                      ))}
                    </div>
                    {formik.touched.otp1 ||
                    formik.touched.otp2 ||
                    formik.touched.otp3 ||
                    formik.touched.otp4 ||
                    formik.touched.otp5 ||
                    formik.touched.otp6 ? (
                      <div className="text-danger fs-6">
                        {formik.errors.otp1 ||
                          formik.errors.otp2 ||
                          formik.errors.otp3 ||
                          formik.errors.otp4 ||
                          formik.errors.otp5 ||
                          formik.errors.otp6}
                      </div>
                    ) : null}
                    <div className="input-block mb-4 text-center">
                      {loading ? (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <button
                          className="btn btn-primary account-btn"
                          type="submit"
                        >
                          Submit
                        </button>
                      )}
                    </div>
                    <div className="account-footer">
                      <p>
                        Not yet received?{" "}
                        <span
                          className="text-primary "
                          style={{ cursor: "grab" }}
                          onClick={ResendOtp}
                        >
                          Resend OTP
                        </span>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
